const BENEFITS = [
  {
    label: "Low investment",
    title: "8 lakh onwards",
  },
  {
    label: "High profits",
    title: "Margins up to 65%",
  },
  {
    label: "Easy operation",
    title: "Training & Equipment",
  },
];

const OTHER_BENEFITS = [
  {
    img: "images/franchisee/low-investment.svg",
    title: "Low Investment",
  },
  {
    img: "images/franchisee/quick-service.svg",
    title: "Quick Service",
  },
  {
    img: "images/franchisee/emi.svg",
    title: "EMI Available",
  },
  {
    img: "images/franchisee/no-chef.svg",
    title: "No Chef Required",
  },
  {
    img: "images/franchisee/professional-team.svg",
    title: "Professional Team Backup",
  },
  {
    img: "images/franchisee/hassle-free.svg",
    title: "Hassle Free",
  },
  {
    img: "images/franchisee/zero-wastage.svg",
    title: "Zero Wastage",
  },
  {
    img: "images/franchisee/easy-operation.svg",
    title: "Easy Operation",
  },
];

const PB_RESPONSIBILITIES = [
  {
    img: "images/franchisee/easy-operation.svg",
    title: "Kitchen Setup",
  },
  {
    img: "images/franchisee/professional-team.svg",
    title: "Staff Training",
  },
  {
    img: "images/franchisee/vendor.svg",
    title: "Material & Vendor Management",
  },
  {
    img: "images/franchisee/sop.svg",
    title: "60 days supervision",
  },
  {
    img: "images/franchisee/logistics.svg",
    title: "Logistics Setup",
  },
  {
    img: "images/franchisee/branding.svg",
    title: "Digital Branding",
  },
];

const FRANCHISEE_RESPONSIBILITIES = [
  {
    img: "images/franchisee/low-investment.svg",
    title: "Capitalizaton Expenses",
  },
  {
    img: "images/franchisee/quick-service.svg",
    title: "Compliance & Legal",
  },
  {
    img: "images/franchisee/marketing.svg",
    title: "Marketing & Maintenence Expenses",
  },
  {
    img: "images/franchisee/location.svg",
    title: "Prime location space",
  },
  {
    img: "images/franchisee/menu.svg",
    title: "Strictly Adherence to Menu",
  },
  {
    img: "images/franchisee/sop.svg",
    title: "Following PB SOPs",
  },
];

export {
  BENEFITS,
  OTHER_BENEFITS,
  PB_RESPONSIBILITIES,
  FRANCHISEE_RESPONSIBILITIES,
};
